// extracted by mini-css-extract-plugin
module.exports = {"content":"da51a739f7--content--AL97H"};